// extracted by mini-css-extract-plugin
export default {"sales":"sales_sales__usQAN","activeSales":"sales_activeSales__bKrC6","historySales":"sales_historySales__GIJGY","body":"sales_body__iwqHa","filters":"sales_filters__dXvL1"};